import api from "../services/api";

export async function getContainer(id) {
  return await api.get("/Container/GetEditModel", {
    params: {
      id: id,
    },
  });
}
